export const FRETTED_INSTRUMENTS = [
  "Guitar",
  "Bass",
  "Ukulele",
  "Mandolin",
] as const;
export const INSTRUMENTS = {
  guitar6: { name: "Guitar", tuning: ["E2", "A2", "D3", "G3", "B3", "E4"] },
  guitar7: {
    name: "7-string guitar",
    tuning: ["B1", "E2", "A2", "D3", "G3", "B3", "E4"],
  },
  bass4: { name: "Bass", tuning: ["E1", "A1", "D2", "G2"] },
  bass5: { name: "5-string bass", tuning: ["B0", "E1", "A1", "D2", "G2"] },
  ukulele: { name: "Ukulele", tuning: ["G4", "C4", "E4", "A4"] },
  mandolin: { name: "Mandolin", tuning: ["G3", "D4", "A4", "E5"] },
} as const;
export type InstrumentId = keyof typeof INSTRUMENTS;
export const TUNINGS: Record<
  InstrumentId,
  Record<string, readonly string[]>
> = {
  guitar6: {
    Standard: INSTRUMENTS.guitar6.tuning,
    "Drop D": ["D2", "A2", "D3", "G3", "B3", "E4"],
    DADGAD: ["D2", "A2", "D3", "G3", "A3", "D4"],
    "Open G": ["D2", "G2", "D3", "G3", "B3", "D4"],
    "Open D": ["D2", "A2", "D3", "F#3", "A3", "D4"],
    "Open E": ["E2", "B2", "E3", "G#3", "B3", "E4"],
    "E♭ standard": ["Eb2", "Ab2", "Db3", "Gb3", "Bb3", "Eb4"],
    "D standard": ["D2", "G2", "C3", "F3", "A3", "D4"],
    "Drop C": ["C2", "G2", "C3", "F3", "A3", "D4"],
  },
  guitar7: {
    Standard: INSTRUMENTS.guitar7.tuning,
    "Drop A": ["A1", "E2", "A2", "D3", "G3", "B3", "E4"],
  },
  bass4: {
    Standard: INSTRUMENTS.bass4.tuning,
    "Drop D": ["D1", "A1", "D2", "G2"],
    "E♭ standard": ["Eb1", "Ab1", "Db2", "Gb2"],
  },
  bass5: { Standard: INSTRUMENTS.bass5.tuning },
  ukulele: {
    Standard: INSTRUMENTS.ukulele.tuning,
    "Low G": ["G3", "C4", "E4", "A4"],
    Baritone: ["D3", "G3", "B3", "E4"],
  },
  mandolin: { Standard: INSTRUMENTS.mandolin.tuning },
};
export const COLOURS = {
  black: "#222222",
  red: "#a82b34",
  blue: "#205a9e",
  green: "#25653e",
  purple: "#704198",
  orange: "#945000",
  teal: "#006c70",
} as const;
export type PitchClass = string;
export interface Dot {
  string: number;
  fret: number;
  finger?: 1 | 2 | 3 | 4 | "T";
  text?: string;
  colour?: keyof typeof COLOURS;
  shape?: "circle" | "square" | "triangle" | "diamond";
  hollow?: boolean;
}
export interface Barre {
  fret: number;
  fromString: number;
  toString: number;
  finger?: 1 | 2 | 3 | 4;
}
export interface NeckDiagram {
  id: string;
  kind: "chord" | "neck" | "wholeNeck";
  title?: string;
  instrument: InstrumentId;
  tuning: string[];
  tuningName?: string;
  fretFrom: number;
  fretTo: number;
  root?: PitchClass;
  labelMode: "none" | "finger" | "note" | "interval" | "custom";
  dots: Dot[];
  barres: Barre[];
  stringMarks: Array<"open" | "muted" | null>;
  source?: {
    type: "chord" | "scale" | "arpeggio";
    name: string;
    root: PitchClass;
  };
}
export interface NeckDiagramSheet {
  schemaVersion: 1;
  title: string;
  notes?: string;
  diagrams: NeckDiagram[];
}
export function newDiagram(
  id: string,
  instrument: InstrumentId = "guitar6",
  kind: NeckDiagram["kind"] = "chord",
): NeckDiagram {
  return {
    id,
    kind,
    instrument,
    tuning: [...INSTRUMENTS[instrument].tuning],
    tuningName: "Standard",
    fretFrom: 0,
    fretTo: kind === "wholeNeck" ? 24 : kind === "neck" ? 12 : 4,
    labelMode: "finger",
    dots: [],
    barres: [],
    stringMarks: INSTRUMENTS[instrument].tuning.map(() => null),
  };
}
